import { useParams } from 'react-router';
import { isBotSystem, type BotRef } from './botNav';

/** The bot of a `/bots/:system/:botId/...` page. Pages render inside <BotWorkspace>, which redirects unknown systems. */
export function useBotRoute(): BotRef {
  const p = useParams();
  return { system: isBotSystem(p.system) ? p.system : 'chatbot', botId: p.botId ?? '' };
}
